<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :collection="formCollection"
      :addBtn="!!batchSelectedKeys?.length"
      addText="批量审批"
      :handelAdd="handelBatchApproval"
      :ableSearch="ableSearch"
      :resetWillRequest="true"
      @reset="handelSearch"
      :ableAdd="ableCheck"
    ></search-form>
    <a-modal
      :width="isBatch ? '520px' : '700px'"
      v-model:open="open"
      :title="pageName"
      :footer="null"
      :destroyOnClose="true"
      :maskClosable="false"
      :keyboard="false"
      :class="isBatch ? '' : 'action-form-model'"
    >
      <action
        :v-if="open"
        @submit="clickOk"
        :isEdit="isEdit"
        :editData="editData"
        :disabled="true"
        :data="tableData"
        :idField="idField"
        :isBatch="isBatch"
      ></action>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :row-selection="rowSelection"
      :rowKey="record => record[idField]"
      :scroll="{x: 'max-content'}"
      :customRow="handleRow"
      size="small"
    >
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.key === 'rowIndex'">
          {{ index + 1 }}
        </template>
        <template v-if="column.key === 'transport_type'">
          {{ ['', '取货','送货'][record.dangerousCargoTransportList?.transport_type] }}
        </template>
        <template v-else-if="column.dataInObject">
          {{
            record[column.dataInObject] &&
            record[column.dataInObject][column.dataIndex]
          }}
        </template>
        <template v-else-if="column.key === 'action'">
          <span>
            <a-button
              @click="showEditModal(record)"
              :loading="loadingRecord === record"
              v-if="ableCheck && record.dangerousCargoTransportList?.state === 1"
            >
              审核
            </a-button>
          </span>
        </template>
      </template>
    </a-table>
  </div>
</template>
<script>
export default {
  name: 'TransportApproval',
}
</script>
<script setup>
  import { ref, onMounted, toRefs, computed } from 'vue'
  import { useStore } from 'vuex'
  import { getData } from '@/api/transport/transport_approval'
  import action from './action'
  import searchForm from '@/components/search_form'
  import { codeToText } from '@/utils/format'
  //初始化
  const pageName = '运单审核'
  const idField = 'process_task_id' //响应数据的id的字段名
  const store = useStore()
  const Enum = toRefs(store.state.common)

  const permissionList = computed(() => store.getters['user/permissionList'])
  const ableSearch = computed(() =>
    // !!permissionList.value?.find(item => item.code === 'transportListApproval:list')
    true
  )
  const ableCheck = computed(() =>
    !!permissionList.value?.find(item => item.code === 'transportListApproval:check')
  )
  const ableShowDept = computed(() =>
    // !!permissionList.value?.find(item => item.code === 'transportListApproval:ShowDept')
    true
  )

  //1、搜索框
  const formCollection = [
    {
      type: 'input',
      field: 'application_number',
      label: '受理单号',
    },
    {
      type: 'input',
      field: 'license_plate',
      label: '申请人证件号码',
    },
    {
      type: 'select',
      field: 'transport_type',
      options: [
        {
          label: '取货',
          value: 1
        },
        {
          label: '送货',
          value: 2
        }
      ],
      label: '运货类型',
      width: '140px',
      'allowClear': true
    },
    {
      type: 'input',
      field: 'unified_social_credit_code',
      label: '承运方统一信用代码',
    },
    {
      type: 'input',
      field: 'driver',
      label: '驾驶员姓名',
    },
    {
      type: 'input',
      field: 'supercargo',
      label: '押运员姓名',
    },
    {
      type: 'input',
      field: 'shipper',
      label: '托运人姓名',
    },
    {
      type: 'select',
      field: 'state',
      storeOptions: 'status',
      label: '审批状态',
      width: '130px',
      'allow-clear': true,
    },
    {
      type: 'dateRange',
      startField: 'shipment_date_start',
      endField: 'shipment_date_end',
      // defaultStart: dayjs().subtract(30, 'day').format('YYYY-MM-DD'),
      // defaultEnd: dayjs().add(30, 'day').format('YYYY-MM-DD'),
      label: '起运日期范围',
    },
  ]
  const searchFormRef = ref()
  function handelSearch() {
    pagination.value.current = 1
    fetch()
    const params = {
      ...searchFormRef.value.formState
    }
    store.commit('search/setPerAppliceApproval', params)
  }

  //2、表格
  const columns = [
    {
      title: '序号',
      dataIndex: 'rowIndex',
      key: 'rowIndex',
      align: 'center',
      width: 50,
      fixed: 'left',
    },
    {
      title: '受理单号',
      dataIndex: 'application_number',
      key: 'application_number',
      dataInObject: 'dangerousCargoTransportList',
      align: 'left',
    },
    {
      title: '运货类型',
      dataIndex: 'transport_type',
      key: 'transport_type',
      dataInObject: 'dangerousCargoTransportList',
      align: 'left',
    },
    {
      title: '运单编号（国家统一运单编号）',
      key: 'list_number',
      dataIndex: 'list_number',
      align: 'left',
      dataInObject: 'dangerousCargoTransportList',
    },
    {
      title: '货物名称',
      key: 'cargo_name',
      dataIndex: 'cargo_name',
      align: 'left',
      dataInObject: 'dangerousCargoTransportList',
    },
    {
      title: '货物数量',
      dataIndex: 'cargo_quantity',
      key: 'cargo_quantity',
      dataInObject: 'dangerousCargoTransportList',
      align: 'left',
    },
    {
      title: '货物单位（吨）',
      dataIndex: 'cargo_unit',
      key: 'cargo_unit',
      dataInObject: 'dangerousCargoTransportList',
      align: 'left',
      width: 130,
    },
    {
      title: '企业名称（承运方）',
      dataIndex: 'enterprise',
      key: 'enterprise',
      dataInObject: 'dangerousCargoTransportList',
      align: 'left',
    },
    {
      title: '统一信用代码（承运方）',
      dataIndex: 'unified_social_credit_code',
      key: 'unified_social_credit_code',
      align: 'left',
      dataInObject: 'dangerousCargoTransportList',
    },
    {
      title: '承运人经营许可证号',
      dataIndex: 'business_license_number',
      key: 'business_license_number',
      dataInObject: 'dangerousCargoTransportList',
      align: 'left',
    },
    {
      title: '承运人联系电话',
      dataIndex: 'contact_phone',
      key: 'contact_phone',
      dataInObject: 'dangerousCargoTransportList',
      align: 'left',
    },
    {
      title: '车牌号码',
      dataIndex: 'license_plate',
      key: 'license_plate',
      dataInObject: 'dangerousCargoTransportList',
      align: 'left',
    },
    {
      title: '起运日期',
      dataIndex: 'shipment_date',
      key: 'shipment_date',
      align: 'left',
      dataInObject: 'dangerousCargoTransportList',
    },
    {
      title: '目的地(省/市/区+详细地址)',
      dataIndex: 'destination',
      key: 'destination',
      align: 'left',
      dataInObject: 'dangerousCargoTransportList',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'left',
      fixed: 'right',
      width: '120px',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const loadingRecord = ref()
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: (total, range) => {
      return `共 ${total} 条`
    },
  })

  function handleTableChange(page) {
    batchSelectedKeys.value = []
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  const handleRow = (record) => {
    return {
      ondblclick: (event) => {
        event.stopPropagation();
        showEditModal(record);
      }
    }
  }

  function fetch() {
    //获取表单值
    const formState = searchFormRef.value?.formState

    loading.value = true
    getData({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data.list
      pagination.value.total = data.total
    })
  }
  const cachedSearchParams = computed(() => store.state.search.searchPerAppliceApproval)
  onMounted(() => {
    for (const key in cachedSearchParams.value) {
      searchFormRef.value.formState[key] = cachedSearchParams.value[key]
    }
    fetch()
  })

  //3、审核
  const open = ref(false)
  const isEdit = ref(true)
  const editData = ref(null)
  const showEditModal = (data) => {
    editData.value = data
    isBatch.value = false
    open.value = true
  }

  function clickOk() {
    fetch()
    handleOk()
    clearEditData()
  }

  const handleOk = () => {
    open.value = false
  }
  const clearEditData = () => {
    editData.value = null
  }

  //4、批量审批
  const batchSelectedKeys = ref()
  const isBatch = ref(false)
  const rowSelection = computed(() => ({
    onChange: (selectedRowKeys, selectedRows) => {
      batchSelectedKeys.value = selectedRowKeys
    },
    selectedRowKeys: batchSelectedKeys.value,
  }))

  function handelBatchApproval() {
    editData.value = {
      [idField]: batchSelectedKeys.value.toString(),
    }
    isBatch.value = true
    open.value = true
  }
</script>
